import { render } from "./DeleteProviderModal.vue?vue&type=template&id=2ddff026"
import script from "./DeleteProviderModal.vue?vue&type=script&lang=js"
export * from "./DeleteProviderModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2ddff026"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ddff026', script)) {
    api.reload('2ddff026', script)
  }
  
  module.hot.accept("./DeleteProviderModal.vue?vue&type=template&id=2ddff026", () => {
    api.rerender('2ddff026', render)
  })

}

script.__file = "resources/js/Modals/DeleteProviderModal.vue"

export default script